
function googleMapsCallbackFunction() {
  var event = new CustomEvent('googleMapsAPI:loaded', {
    bubbles: true
  });
  window.dispatchEvent(event)
}
window.googleMapsCallbackFunction = googleMapsCallbackFunction
